import { Validators } from '@angular/forms';

export const PasswordValidator = Validators.pattern(/(?=.*[#?!@$%^&*-]+)(?=.*\d+)(?=.*[a-z]+)(?=.*[A-Z]+).{6,}/);
export const EmailValidator = Validators.pattern(/^[^@]+@[^@]+\.[^@]+$/);
